import React from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { formatDateTime } from "utils/time-utils";
import { Button } from "primereact/button";
import { exportToCSV, generateTableData, WeatherTableProps } from "./WeatherMonitoringUtils";
import { WeatherMonitoringTableColumnRowData } from "../charts/interfaces";

const tableColumns = [
  {
    field: "time",
    header: "Time",
    body: (rowData: WeatherMonitoringTableColumnRowData) => formatDateTime(rowData.time, "HH:mm"),
    width: "5rem",
  },
  { field: "temperature", header: "Temperature", width: "8rem" },
  {
    field: "windSpeed",
    header: "Wind Speed",
    width: "8rem",
  },
  {
    field: "windDirection",
    header: "Wind Direction",
    width: "8rem",
    body: (rowData: WeatherMonitoringTableColumnRowData) => (
      <div className="flex flex-row justify-content-between">
        <div>{rowData.windDirection}</div>
        <Button
          icon="pi pi-arrow-up"
          disabled
          className="p-button-text p-button-secondary p-0"
          style={{ transform: `rotate(${parseFloat(rowData.windDirection)}deg)` }}
        />
      </div>
    ),
  },
  { field: "gusture", header: "Gusture", width: "8rem" },
  { field: "precipitation", header: "Precipitation", width: "8rem" },
  { field: "humidity", header: "Humidity", width: "8rem" },
  { field: "feelsLikeTemperature", header: "Feels Like", width: "8rem" },
];

const WeatherMonitoringTable = ({
  datasetsData,
  props,
  dayOffset,
  endHour,
  tabHeader,
}: WeatherTableProps) => {
  const tableData = generateTableData(datasetsData, props, dayOffset, endHour);

  const handleExportCSV = () => {
    exportToCSV(tableData, `weather_data_${tabHeader}`);
  };

  return (
    <div className="overflow-x-auto">
      <Button
        type="button"
        icon="pi pi-file"
        onClick={handleExportCSV}
        className="p-button-sm mb-2 ml-5"
        label="CSV"
      />
      <DataTable value={tableData} className="ml-5 w-max" showGridlines size="small" stripedRows>
        {tableColumns.map(col => (
          <Column
            key={col.field}
            field={col.field}
            header={col.header}
            body={col.body}
            style={{ width: col.width }}
          />
        ))}
      </DataTable>
    </div>
  );
};

export default WeatherMonitoringTable;
